module.exports = {"name":"Link","description":"Link block","fields":[{"name":"data.url","label":"Link URL","type":"text"},{"name":"data.link","label":"Link text","type":"text"},{"name":"data.title","label":"Title","type":"text"},{"name":"data.description","label":"Description","type":"text","props":{"type":"textarea"}}]}


//////////////////
// WEBPACK FOOTER
// ./components/blocks/definitions/link.json
// module id = 697
// module chunks = 185 187